import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { TextField, Grid } from '@mui/material'

import BaseDialog from '../../BaseDialog'

import { useDataApi } from '../../../context/DataApiContext'
import { useNotificationsProvider } from '../../../context/NotificationsContext'
import AutoCompleteInput from '../../AutoCompleteInput'

export default function CreateDepotDialog({ open, onClose, onCreated }) {
  const { t } = useTranslation()

  const { dataProvider } = useDataApi()
  const { showNotification } = useNotificationsProvider()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [name, setName] = useState('')
  const [operatorIds, setOperatorIds] = useState([])

  const resource = 'depots'

  const resetState = () => {
    // Clean form
    setLoading(false)
    setError('')
    setName('')
    setOperatorIds([])
  }

  const onCloseDialog = (event, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      onClose()
    } else {
      resetState()
      onClose()
    }
  }

  const onConfirm = () => {
    if (name.length === 0) {
      setError('name_required')
      return
    }

    if (operatorIds.length === 0) {
      setError('operatorIds_required')
      return
    }

    const body = {
      data: {
        name,
        operatorIds: operatorIds.map((operator) => operator.id),
      },
    }

    setLoading(true)
    dataProvider
      .post(resource, body)
      .then(() => {
        dataProvider.cache.reset()
        showNotification('success', t('create-depot-dialog.success'))
        onCreated()
      })
      .catch((err) => {
        if (err.response.data.error === 'DEPOT_ALREADY_EXISTS') {
          showNotification(
            'error',
            t('create-depot-dialog.already-exists-error')
          )
        } else {
          showNotification('error', t('errors.api-error'))
        }
      })
      .then(() => resetState())
  }
  return (
    <BaseDialog
      open={open}
      onClose={onCloseDialog}
      onConfirm={onConfirm}
      title={t('create-depot-dialog.title')}
      loading={loading}
    >
      <Grid container direction="column" spacing={4}>
        <Grid item>
          <TextField
            variant="standard"
            required
            error={error === 'name_required'}
            helperText={t('common.required')}
            id="name"
            label={t('create-depot-dialog.depot-name')}
            fullWidth
            value={name}
            onChange={(event) => setName(event.target.value)}
          />
        </Grid>
        <Grid item>
          <AutoCompleteInput
            onChange={setOperatorIds}
            value={operatorIds}
            label={t('create-depot-dialog.operators')}
            resource="/operators/autocomplete"
            error={error === 'operatorIds_required'}
            helperText={t('common.required')}
            multiple
            required
            canDelete
            onKeyDown={(e) => {
              if (e.keyCode === 13 && e.target.value) {
                setOperatorIds(
                  operatorIds.concat({
                    id: (operatorIds.length + 1) * -1,
                    title: (e.target.value || '').trim(),
                  })
                )
              }
            }}
          />
        </Grid>
      </Grid>
    </BaseDialog>
  )
}
